import { Component, OnInit } from '@angular/core';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { ReferralService } from 'src/app/services/referral.service';
declare var $: any;

@Component({
  selector: 'app-lab',
  templateUrl: './lab.component.html',
  styleUrls: ['./lab.component.css']
})
export class LabComponent implements OnInit {
  selectedLanguage: any = 'en';
  labOrderResponse: any;
  personalInfo: any;
  labId: any;
  isImagingOrder: boolean = false;
  laborImaging: any = 'lab';
  constructor(private _phrutilService: PhrutillsService, private spinner: NgxSpinnerService,
    private referralService: ReferralService, private _route: ActivatedRoute, private _router: Router) {
    let info = localStorage.getItem('PatientInfo');
    if (!info) {
      this._router.navigateByUrl("/home?practice_code=''");
      return;
    }
  }
  ngOnInit(): void {
    let lang = localStorage.getItem('language');
    if (lang) {
      this.selectedLanguage = lang;
    } else {

      this.selectedLanguage = 'en'
    }
    console.log("labOrder component");
    this.personalInfo = localStorage.getItem('PatientInfo');
    this.labId = localStorage.getItem('labid');
    if (this.personalInfo) {
      this.personalInfo = this._phrutilService.decrypt(this.personalInfo);
      //console.log("personal info", this.personalInfo);

      if (this.labId != undefined && this.labId != null) {
        this.getLabOrderDetails(this.labId);
      }
    }

    this._phrutilService.setTitle('Verify Patient');
   

  }

  getLabOrderDetails(labid: any) {
    this.spinner.show();
    this.referralService.GetLabOrderDetails(this.personalInfo.patient_Account, labid).subscribe((res: any) => {
      this.spinner.hide();
     // console.log("res", res);
      if (res.data.patient_order_id) {
        this.labOrderResponse = res.data;
        if (this.labOrderResponse.imagingorder == 'False') {
          this.isImagingOrder = false;
          this.laborImaging = 'lab';
        } else {
          this.isImagingOrder = true;
          this.laborImaging = 'imaging';
        }
        this.laborImaging = this.toTitleCase(this.laborImaging)
        this.labOrderResponse.lab_phone = this.maskPhoneNumber(this.labOrderResponse.lab_phone);

        if (this.labOrderResponse.patient_account !== this.personalInfo.patient_Account) {
          console.log("not matched");
          this._router.navigateByUrl("/home?practice_code=" + this.personalInfo.practice_code + "&labid=" + this.labId + "&from=usernotmatched");
        } else {
          console.log("not matched");
          //this._router.navigateByUrl("/home?practice_code=" + this.personalInfo.practice_code + "&labid=" + this.labId);
        }
      } else {
        this._router.navigateByUrl("/home?practice_code=" + this.personalInfo.practice_code + "&labid=" + this.labId + "&from=noLabFound");
      }

    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this._phrutilService.showError(text);
      this._router.navigateByUrl("/home?practice_code=" + this.personalInfo.practice_code + "&labid=" + this.labId + "&from=noLabFound");
    });
  }

  toTitleCase(name: string): string {
    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  maskPhoneNumber(phoneNo: any) {
    //mask phonenumber
    if (phoneNo == '' || phoneNo == null || phoneNo == undefined) {
      return '';
    }
    const ptPhoneNumber = phoneNo;
    const sanitizedptPhoneNumber = ptPhoneNumber.replace(/[^0-9]/g, ''); // Removes all non-numeric characters
    return this._phrutilService.maskingPhoneNumer(sanitizedptPhoneNumber)
  }




  generatePDF() {
    this.spinner.show();

    this.referralService.getLabOrderPdf(this.personalInfo.patient_Account,this.labId).subscribe({

      next: (pdfBlob: any) => {
        this.spinner.hide();

        try {
          if (!pdfBlob) {
            this._phrutilService.showError("Unable to download " + this.laborImaging + " order, please try later.");
            return;
          }

          const blob = new Blob([pdfBlob], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = 'LabOrderPrint.pdf';
          a.click();

          window.URL.revokeObjectURL(url);

          this._phrutilService.showSuccess("Successfully downloaded " + this.laborImaging + " order.");
        }
        catch (err) {
          console.error("PDF processing error:", err);
          this._phrutilService.showError("PDF could not be downloaded. Please try later.");
        }
      },

      error: (error) => {
        this.spinner.hide();

        console.error("Service error:", error);

        let msg = "Service is not available, please try later.";
        if (error.status === 404) msg = this.laborImaging + " order PDF not found.";
        if (error.status === 500) msg = "Server error generating PDF.";

        this._phrutilService.showError(msg);
      }

    });
  }

}
